import { useEffect, useState } from 'react';
import { SESSION_EXPIRED_EVENT, isEmbedded } from '~/lib/auth';

/**
 * Last resort when a request comes back 401 and the session can't be renewed by
 * any means. Without this the failure surfaces as an error on whatever the user
 * was doing ("Error al preparar el pedido"), which sends people rechecking
 * their data instead of their session.
 *
 * Reloading is the actual fix in both contexts: standalone it bounces through
 * the login guard, embedded it remounts the frame with a token the host just
 * refreshed.
 */
export default function SessionExpiredNotice() {
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    const onExpired = () => setExpired(true);
    window.addEventListener(SESSION_EXPIRED_EVENT, onExpired);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, onExpired);
  }, []);

  if (!expired) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="max-w-sm space-y-3 rounded-lg bg-base-100 p-6 text-center shadow-xl">
        <div className="text-lg font-semibold">Tu sesión expiró</div>
        <p className="text-sm text-base-content/70">
          No se guardó lo que estabas haciendo. Recarga la página para volver a
          entrar y vuelve a intentarlo.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="btn btn-primary btn-sm w-full"
        >
          Recargar
        </button>
        {!isEmbedded() && (
          <p className="text-xs text-base-content/50">
            Si vuelve a pasar, cierra sesión y entra de nuevo.
          </p>
        )}
      </div>
    </div>
  );
}
